import React from 'react';
import BaseDialogContainer from '../baseContainers/BaseDialogContainer';
import {withTranslation} from 'react-i18next';
import PropTypes from 'prop-types';
import DivContainer from '../components/DivContainer';
import {ActionButton} from '../components/ActionButton';
import CardUserService from '../services/CardUserService';
class MobileUserAuthorizeDialog extends BaseDialogContainer {
    constructor(props) {
        super(props, new CardUserService());
        this.state = {
            viewMode: this.props.viewMode,
        };
        this.renderFooter = this.renderFooter.bind(this);
        this.renderSaveLabel = this.renderSaveLabel.bind(this);
    }
    getContainerListName() {
        return 'mobile-user-authorize-dialog';
    }
    renderSaveLabel() {
        const {t, userAction} = this.props;
        return userAction === 'AUTHORIZE' ? t('cards.userDetails.authorizeButton') : t('cards.userDetails.unauthorizeButton');
    }
    renderFooter() {
        const {t} = this.props;
        return (
            <div className='footer-dialog-button-container'>
                <ActionButton
                    label={t('details.cancel')}
                    variant={'button cancel-button white'}
                    handleClick={(e) => this.props.onHide(undefined)}
                />
                <ActionButton label={this.renderSaveLabel()} variant='button save-button fullred' handleClick={this.handleFormSubmit} />
            </div>
        );
    }
    translate(key) {
        const {t} = this.props;
        return t(key);
    }

    renderHeader() {
        const {userAction, t} = this.props;
        return (
            <React.Fragment>
                <DivContainer colClass='col-12 back-off-auth-dialog-header'>
                    <DivContainer colClass='col-12'>
                        <label id={`back-off-auth-dialog-header-label-id`}>
                            {userAction === 'AUTHORIZE' ? t('cards.userDetails.authorizeButton') : t('cards.userDetails.unauthorizeButton')}
                        </label>
                    </DivContainer>
                </DivContainer>
            </React.Fragment>
        );
    }
    setElement() {
        this.initAfterSetElement();
    }
    createOrUpdate() {
        const {t, userAction, phoneNumber} = this.props;
        this.scrollToTop();
        if (this.props._isMounted) {
            const request = {phoneNumbers: [phoneNumber]};
            if (userAction === 'AUTHORIZE') {
                this.service
                    .authorizeMobileUser(request)
                    .then((response) => {
                        this.blockUi();
                        if (this.props.afterSave) {
                            this.showSuccessMessage(t('cards.userDetails.authorizeSuccess'));
                            this.unblockUi();
                            this.props.afterSave();
                        }
                        if (this.props.handleSuccess) {
                            this.unblockUi();
                            this.props.handleSuccess(response);
                        }
                    })
                    .catch((err) => {
                        if (this.props.afterSave) {
                            this.showErrorMessage(t('error.errorAuthorizeMobileUser'));
                            this.unblockUi();
                            this.props.afterSave();
                        }
                        if (this.props.handleError) {
                            this.unblockUi();
                            this.props.handleError();
                        }
                    });
            } else {
                this.service
                    .unauthorizeMobileUser(request)
                    .then((response) => {
                        this.blockUi();
                        if (this.props.afterSave) {
                            this.showSuccessMessage(t('cards.userDetails.unauthorizeSuccess'));
                            this.unblockUi();
                            this.props.afterSave();
                        }
                        if (this.props.handleSuccess) {
                            this.unblockUi();
                            this.props.handleSuccess(this.state.element);
                        }
                    })
                    .catch((err) => {
                        if (this.props.afterSave) {
                            this.showErrorMessage(t('error.errorUnauthorizeMobileUser'));
                            this.unblockUi();
                            this.props.afterSave();
                        }
                        if (this.props.handleError) {
                            this.unblockUi();
                            this.props.handleError();
                        }
                    });
            }
        }
    }

    renderDetails() {
        const {t, userAction, phoneNumber} = this.props;
        return (
            <div className='back-off-container'>
                <DivContainer colClass=''>
                    <span>
                        {userAction === 'AUTHORIZE' ? t('cards.userDetails.authorizeDesc') : t('cards.userDetails.unauthorizeDesc')}
                    </span>
                    <span className='bold'>{phoneNumber}</span>
                </DivContainer>
                <DivContainer colClass='back-off-row' rendered={userAction === 'UNAUTHORIZE'}>
                    <div className='back-off-auth-label'>{t('cards.cardUnauthorizeDesc')}</div>
                </DivContainer>
            </div>
        );
    }
}

MobileUserAuthorizeDialog.defaultProps = {
    currentUser: undefined,
    viewMode: 'VIEW',
};

MobileUserAuthorizeDialog.propTypes = {
    currentUser: PropTypes.object,
    visible: PropTypes.bool,
    onHide: PropTypes.func,
    afterSave: PropTypes.func,
    phoneNumber: PropTypes.string,
    userAction: PropTypes.string,
};

export default withTranslation()(MobileUserAuthorizeDialog);
